export default __webpack_public_path__ + "static/media/userIcon.c59d6b8a.jpg";